import moment from 'moment';

moment.locale('es');

export default function (value: string){
    if(!value) return '-';
    return moment(value).fromNow();
}